import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { motion } from "framer-motion";

const aboutHeroBg =
  "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?q=80&w=2070&auto=format&fit=crop";

const HeroSection = () => {
  return (
    <Box
      sx={{
        width: "100%",
        minHeight: { xs: "350px", md: "500px" },
        height: { xs: "auto", md: "500px" },
        backgroundImage: `linear-gradient(to right, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.2) 100%), url(${aboutHeroBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center 45%",
        display: "flex",
        alignItems: "flex-start",
        pt: { xs: "100px", md: "210px" },
        position: "relative",
        opacity: 1,
        overflow: "hidden",
        pb: { xs: "30px", md: 0 },
      }}
    >
      <Container
        maxWidth={false}
        sx={{
          maxWidth: { xs: "100%", lg: "1536px" },
          width: "100%",
          pl: { xs: "24px", md: "48px" },
          pr: { xs: "24px", md: "48px" },
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          gap: { xs: "12px", md: "16px" },
          position: "relative",
          zIndex: 2,
        }}
      >
        {/* Main Content Stack */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {/* Title Box */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            style={{ width: "100%", maxWidth: "850px" }}
          >
            <Typography
              component="h1"
              sx={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: 800,
                fontSize: { xs: "38px", sm: "52px", md: "68px", lg: "80px" },
                lineHeight: { xs: "1.1", md: "115%" },
                letterSpacing: { xs: "-1px", md: "-2.8px" },
                color: "#FFFFFF",
                verticalAlign: "middle",
                textShadow: "0px 4px 20px rgba(0,0,0,0.5)",
                textAlign: "left",
              }}
            >
              The Legacy of
              <Box
                component="span"
                sx={{
                  letterSpacing: "0px",
                  color: "#FF5722",
                  display: "block",
                }}
              >
                Abilio Realty
              </Box>
            </Typography>
          </motion.div>

          {/* Description Box */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3, ease: "easeOut" }}
            style={{ width: "100%", maxWidth: "650px" }}
          >
            <Typography
              sx={{
                width: "100%",
                fontFamily: "Inter, sans-serif",
                fontWeight: 300,
                fontSize: { xs: "16px", md: "20px" },
                lineHeight: { xs: "24px", md: "30px" },
                letterSpacing: "0.4px",
                color: "rgba(255, 255, 255, 0.9)",
                verticalAlign: "middle",
                textAlign: "left",
              }}
            >
              Curating exceptional architectural narratives and luxury living
              spaces for over two decades.
            </Typography>
          </motion.div>
        </Box>
      </Container>

      {/* EST Branding element - Moved near the end/bottom and increased size */}
      <motion.div
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, delay: 0.5, ease: "easeOut" }}
        style={{
          position: "absolute",
          bottom: "40px",
          left: "48px",
          zIndex: 3,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
            opacity: 0.7,
          }}
        >
          {/* Increased line width */}
          <Box sx={{ width: "40px", height: "1px", bgcolor: "#FFFFFF" }} />
          <Typography
            sx={{
              fontFamily: "Inter, sans-serif",
              // Increased font size
              fontSize: { xs: "11px", md: "13px" },
              color: "#FFFFFF",
              letterSpacing: "2.5px",
              textTransform: "uppercase",
              fontWeight: 500,
            }}
          >
            EST. 2018
          </Typography>
        </Box>
      </motion.div>

      {/* Decorative glass overlay */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            "radial-gradient(circle at 20% 50%, rgba(255, 87, 34, 0.05) 0%, transparent 50%)",
          pointerEvents: "none",
        }}
      />
    </Box>
  );
};

export default HeroSection;
